import { render } from "./NotFoundView.vue?vue&type=template&id=5cbeb169&scoped=true"
const script = {}

import "./NotFoundView.vue?vue&type=style&index=0&id=5cbeb169&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.27_vue@3.5.27_typescript@5.3.3__webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cbeb169"]])

export default __exports__